import { Layout } from "antd";
import { useState } from "react";
import {
  TbLayoutSidebarRightCollapse,
  TbLayoutSidebarRightExpand,
} from "react-icons/tb";
import { Outlet } from "react-router-dom";
import SideBar from "../layouts/SideBar";

export default function SetupLayout() {
  const [collapsed, setCollapsed] = useState(false);
  return (
    <>
      <Layout>
          {/* <Layout.Sider
            trigger={null}
            collapsed={collapsed}
            className='fixed z-10 bg-[#0e0d12] overflow-y-auto overflow-x-hidden'
            style={{ height: "calc(108vh - 102px)" }}
          >
            <div className='w-full md:hidden pt-2 pr-2 text-white flex justify-end'>
              <TbLayoutSidebarRightExpand
                onClick={() => setCollapsed(true)}
                className='text-3xl inline-block'
              />
            </div>

            <SideBar />
          </Layout.Sider> */}
        <Layout.Content
          className='bg-[#F2F2F2] px-4 overflow-y-auto overflow-x-hidden'
          // style={{ height: "calc(100vh - 102px)" }}
        >
          {collapsed && (
            <div className='p-1 absolute left-0 z-10'>
              <TbLayoutSidebarRightCollapse
                onClick={() => setCollapsed(false)}
                className='text-3xl inline-block'
              />
            </div>
          )}
          <Outlet />
        </Layout.Content>
      </Layout>
    </>
  );
}
